export default {
    name: "EmptyLayout"
}